import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-claro-tag',
  templateUrl: './claro-tag.component.html',
  styleUrls: ['./claro-tag.component.scss']
})
export class ClaroTagComponent implements OnInit{
  @Input() height : string = '24px';
  @Input() width: string = '';
  @Input() iconName : string = '';
  @Input() backgroundColor : string = '';
  @Input() fontColor :  string = '#000000';
  @Input() fontSize : string = '16px';
  @Input() iconSize : string = '22px';
  @Input() text : string = "";

  ngOnInit(): void {
    
  }

}
